export const VIEW_ITEM_STATES = {
    INITIALIZING: 'INITIALIZING',
    ACTIVE: 'ACTIVE',
    ENDING: 'ENDING',
    ENDED: 'ENDED'
};

export const ITEM_STATES = {
    ONGOING_AUCTION: 'ONGOING_AUCTION',
    ONGOING_AUCTION_BIN: 'ONGOING_AUCTION_BIN',
    ONGOING_FIXED_PRICE: 'ONGOING_FIXED_PRICE',
    ENDED_AUCTION_WITHOUT_BID: 'ENDED_AUCTION_WITHOUT_BID',
    ENDED_AUCTION_WITH_WINNING_BID: 'ENDED_AUCTION_WITH_WINNING_BID',
    ENDED_AUCTION_WITHOUT_WINNING_BID: 'ENDED_AUCTION_WITHOUT_WINNING_BID',
    ENDED_AUCTION_BIN_BOUGHT_AS_BIN: 'ENDED_AUCTION_BIN_BOUGHT_AS_BIN',
    ENDED_FIXED_PRICE: 'ENDED_FIXED_PRICE',
    ENDED_CANCELLED: 'ENDED_CANCELLED',
    UNKNOWN: 'UNKNOWN'
};
